import clsx from 'clsx';

export interface SkeletonProps {
  width?: string;
  height?: string;
  className?: string;
  'aria-label'?: string;
}

export function Skeleton({ width = '100%', height = '20px', className, ...rest }: SkeletonProps) {
  return (
    <span
      className={clsx('skeleton', className)}
      style={{ display: 'block', width, height }}
      aria-hidden={rest['aria-label'] ? undefined : true}
      {...rest}
    />
  );
}
